import styled from 'styled-components';

export const MainWrapper = styled.div<{ isNewPd: boolean }>`
  margin-top: 1rem;
  width: ${({ isNewPd }) => (isNewPd ? '100%' : '62%')};
`;

export const BannerCarouselWrapper = styled.div`
  overflow: hidden;
`;

export const SliderWrapper = styled.div`
  position: relative;

  .slick-disabled {
    display: none;
  }

  .slick-track {
    display: flex;
    align-items: start;
  }

  .slick-list {
    overflow: hidden;
  }
`;
